import { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import "./LiveTranscriptModal.css";

const token = process.env.REACT_APP_TOKEN_BLOB_UPLOAD;

const LiveTranscriptModal = ({ isOpen, toggle }) => {
  const [displayText, setDisplayText] = useState("");
  const [loading, setLoading] = useState(true);

  const fullTextRef = useRef("");
  const fetchIntervalRef = useRef(null);
  const textEndRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const fetchTranscript = async () => {
      try {
        const res = await fetch(
          `https://devlnxstorage.blob.core.windows.net/abs-storage/transcription.txt${token}&t=${Date.now()}`
        );
        const text = await res.text();
        setLoading(false);

        const oldText = fullTextRef.current;
        if (text.length > oldText.length) {
          const newChunk = text.slice(oldText.length);
          fullTextRef.current = text;
          setDisplayText((prev) => prev + newChunk);
        }
      } catch (err) {
        console.error("Erro ao buscar transcrição:", err);
      }
    };

    fetchTranscript();
    fetchIntervalRef.current = setInterval(fetchTranscript, 3000);

    return () => {
      clearInterval(fetchIntervalRef.current);
      fullTextRef.current = "";
      setDisplayText("");
      setLoading(true);
    };
  }, [isOpen]);

  useEffect(() => {
    if (textEndRef.current) {
      textEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [displayText]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Transcrição ao Vivo</ModalHeader>
      <ModalBody className="modal-body-custom">
        {loading ? (
          <Spinner color="primary" />
        ) : (
          <p className="typed-text">
            {displayText}
            <span className="blinking-cursor">|</span>
            <div ref={textEndRef} />
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LiveTranscriptModal;
